export default __webpack_public_path__ + "media/images/facebook-image-691f27624e7da339cfe5c8225ea3e9a5.png";